var r={borderColor:100};export{r as default};
